import { ContatoMencionado } from 'types';
import parseTextToHtml from 'utils/parseTextToHtml';

export function renderTextWithMentions(
  texto: string,
  contatosMencionados: ContatoMencionado[],
  searchQuery?: string,
): string {
  if (!contatosMencionados?.length) {
    return parseTextToHtml(texto, searchQuery);
  }

  let html = parseTextToHtml(texto, searchQuery);

  contatosMencionados.forEach(contato => {
    const alias = `@${contato.contatoNome || contato.waPhoneNumberId}`;

    const escapedId = contato.waPhoneNumberId.replace(
      /[.*+?^${}()|[\]\\]/g,
      '\\$&',
    );
    // evita casar prefixos, ex.: "@todos" dentro de "@todosOsDias"
    const regex = new RegExp(`@${escapedId}(?![\\w\\u00C0-\\u017F])`, 'g');

    const escapedNome = (contato.contatoNome || '').replace(/"/g, '&quot;');

    html = html.replace(
      regex,
      `<a class="mention" data-contato-id="${
        contato.contatoId ?? ''
      }" data-contato-nome="${escapedNome}" data-contato-phone="${
        contato.waPhoneNumberId || ''
      }">${alias}</a>`,
    );
  });

  return html;
}
